export const AUTH_TYPES = {
    AUTH_REQUEST: 'AUTH REQUEST',
    AUTH_FAILURE: 'AUTH FAILURE',
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGIN_STORE_REQUEST: 'LOGIN_STORE_REQUEST',
    LOGIN_STORE_SUCCESS: 'LOGIN_STORE_SUCCESS',
    LOGIN_STORE_FAILURE: 'LOGIN_STORE_FAILURE',
    USER_IS_FETCHING: 'USER_IS_FETCHING',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',
    LOGIN_FORGOT_PASSWORD_REQUEST: 'LOGIN FORGOT PASSWORD REQUEST',
    LOGIN_FORGOT_PASSWORD_REQUEST_SUCCESS: 'LOGIN FORGOT PASSWORD REQUEST SUCCESS',
    LOGIN_FORGOT_PASSWORD_REQUEST_FAILURE: 'LOGIN FORGOT PASSWORD REQUEST FAILURE',
    LOGIN_RESET_PASSWORD_REQUEST_SUCCESS: 'LOGIN RESET PASSWORD REQUEST SUCCESS',
    CLEAN_ERRORS: 'CLEAN_ERRORS',
    CHANGE_PROFILE: 'CHANGE_PROFILE',
    // HO-ISSUE-119: la lista de propiedades vinculadas venia del login y no se
    // volvia a pedir, asi que "Cambiar de propiedad" mostraba nombres viejos.
    UPDATE_MY_PROPERTIES: 'UPDATE_MY_PROPERTIES',
    SET_CURRENCY: 'SET_CURRENCY',
};


export const CONDOMINIUM_TYPES = {
    SELECT_CONDOMINIUM: 'SELECT_CONDOMINIUM',
    CONDOMINIUM_NAME: 'CONDOMINIUM_NAME',
    CONDOMINIUM_ADDRESS: 'CONDOMINIUM_ADDRESS',
    CONDOMINIUM_ID: 'CONDOMINIUM_PHONE',
    UNSELECT_CONDOMINIUM: 'UNSELECT_CONDOMINIUM',
    SELECT_PROVIDER:'SELECT_PROVIDER',
    UNSELECT_PROVIDER: 'UNSELECT_PROVIDER',
    MAKING_REQUEST: 'MAKING_REQUEST',
    NOT_MAKING_REQUEST: 'NOT_MAKING_REQUEST'
}

export const UI_TYPES = {
    UI_IS_DARK: 'UI_IS_DARK',
}

// HO-HU-37: propiedad activa para cuentas "property" con mas de una
// propiedad vinculada.
export const PROPERTY_TYPES = {
    SELECT_PROPERTY: 'SELECT_PROPERTY',
    UNSELECT_PROPERTY: 'UNSELECT_PROPERTY',
    // HO-ISSUE-119: renombrar el inmueble desde "Mi perfil" dejaba el navbar
    // mostrando el nombre viejo, porque el label solo se escribia al elegir
    // la propiedad.
    RENAME_SELECTED_PROPERTY: 'RENAME_SELECTED_PROPERTY',
}